import { render, staticRenderFns } from "./EditTrainer.vue?vue&type=template&id=52df6a26&scoped=true&"
import script from "./EditTrainer.vue?vue&type=script&lang=js&"
export * from "./EditTrainer.vue?vue&type=script&lang=js&"
import style0 from "./EditTrainer.vue?vue&type=style&index=0&id=52df6a26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52df6a26",
  null
  
)

export default component.exports